import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { Component, Input } from "@angular/core";
import { JobsService } from "../../../dashboard/main/accountant/jobs-and-tasks/jobs.service";
import { HotToastService } from "@ngneat/hot-toast";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { AccountantService } from "../../main/accountant/accountant.service";
import { Company } from "../../shared-data.service";
import { Job } from "../../main/accountant/jobs-and-tasks/job.model";

@Component({
  selector: "remove-staff-modal",
  templateUrl: "./remove-staff-modal.component.html",
  imports: [DropdownModule, FormsModule],
})
export class RemoveStaffModalComponent implements OnInit {
  
  @Input() accountants: any[];
  @Input() company: Company;
  @Input() userToBeDeletedId: number;

  preLoading: boolean = true;
  loading: boolean = false;
  inCountdown = false;
  countdown = 5;
  jobs: any[] = [];
  selectedNewOwner: any = null;
  setOnRepeatJobs: boolean = false;
  userHasAssignments: boolean = false;

  public onClose: Subject<boolean>;

  public constructor(
    private toastr: HotToastService,
    private jobsService: JobsService,
    private accountantService: AccountantService,
    public modalService: BsModalService,
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
    this.startCountdown();
    this.accountants = this.accountants.filter(
      (accountant) => accountant.user.id !== this.userToBeDeletedId,
    );
    this.onClose = new Subject();
    this.preLoading = true;
    this.accountantService
      .get_staff_assignments(this.userToBeDeletedId)
      .then((res) => {
        if (res?.jobs?.length > 0) {
          this.userHasAssignments = true;
          this.jobs = res.jobs;
        }
      })
      .catch((err) => {
        this.toastr.warning("Failed to check user assignments");
      })
      .finally(() => (this.preLoading = false));
  }

  startCountdown() {
    this.inCountdown = true;
    this.countdown = 5;
    const interval = setInterval(() => {
      if (this.countdown > 1) {
        this.countdown--;
      } else {
        this.inCountdown = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  confirm() {
    this.loading = true;
    if (this.userHasAssignments)
    {
      this.removeUserAndAssignments();
    }
    else {
      this.removeUser();
    }
  }

  private removeUserAndAssignments() {
    this.loading = true;
    this.jobsService
      .changeJobOwnership(
        this.selectedNewOwner,
        this.jobs,
        true)
      .pipe(
        this.toastr.observe({
          success: "Jobs successfully assigned.",
          loading: "Assigning jobs...",
          error: "There was an error reassigning the jobs.",
        })
      )
      .subscribe({
        next: (res) => console.log(res),
        error: (err) => console.error(err),
        complete: () => {
          this.removeUser();
        }
      });
  }

  private removeUser() {
    this.accountantService.delete_staff_with_status(this.userToBeDeletedId).then(
      (res: any) => {
        const response = res.body;
        if (res.status === 207) {
          this.toastr.warning(res.body.message);
        }

        this.loading = false;
        this.bsModalRef.hide();
        this.onClose.next(true);
        this.toastr.success("Staff successfully removed.");
      },
      (err) => {
        this.toastr.error("There was an error removing the staff.");
        this.loading = false;
        console.error(err);
        this.bsModalRef.hide();
        this.onClose.next(false);
      });
  }

  cancel() {
    this.onClose.next(false);
  }
}
